module.exports = __webpack_public_path__ + "static/media/heart.36aa38f5.svg";